import type { CapsuleDetail } from '@/types/intelligence.types';
import type { CapsuleSchemaResponse } from './intelligence.service';

function metadataString(metadata: Record<string, unknown> | undefined, key: string) {
  const value = metadata?.[key];
  return typeof value === 'string' && value.trim() ? value.trim() : undefined;
}

/** Runtime stream descriptors are authoritative; no legacy schema probe is needed. */
export function capsuleSchemaFromDetail(capsule: CapsuleDetail): CapsuleSchemaResponse {
  return {
    capsule_id: capsule.id,
    version: String(capsule.schemaVersion ?? ''),
    json_schema: {},
    tables: (capsule.streams ?? []).map((stream) => ({
      name: stream.name,
      display_name: metadataString(stream.metadata, 'displayName') ?? stream.name,
      source_label:
        metadataString(stream.metadata, 'sourceLabel') ??
        metadataString(stream.metadata, 'sourceFilename') ??
        (stream.streamKind === 'connector' ? capsule.sourceKind : undefined),
      columns: (stream.columns ?? []).map((column) => ({
        name: column.name,
        data_type: column.type,
        nullable: column.nullable,
        required_on_insert: column.required,
      })),
    })),
  };
}
